<template>

    <div v-if="isVisible" class="modal-overlay modal">
        <div class="modal-content w-50 p-0">

            <form @submit.prevent="addParceria()">
                <div class="modal-header p-3">
                    <h5 class="mb-0">Adicionar Parceria</h5>
                    <i class="ri-close-line cursor-pointer" @click="closeModal"></i>
                </div>

                <div class="modal-body p-3">

                    <div class="mb-3 d-flex gap-2" >

                        <div class="flex-1">
                            <InputField 
                            :required="true" 
                            label="Nome da parceria *" 
                            type="text" 
                            placeHolder="Digite aqui o nome da parceria *"
                            v-model="newParceria.nome"
                            />
                        </div>

                    </div>

                    <div class="mb-0 d-flex gap-2" >

                        <div class="flex-1">
                            <InputField 
                            :required="true" 
                            label="Percentual de desconto *" 
                            type="number" 
                            placeHolder="Digite aqui o percentual de desconto *"
                            v-model="newParceria.percentual_desconto"
                            min="0"
                            max="100"
                            step="0.01"
                            />
                        </div>

                    </div>
                

                </div>

                <div class="modal-footer p-3">

                    <ButtonField @click="closeModal" size="small" text="Fechar" type="light"></ButtonField>

                    <ButtonField size="small" text="Adicionar" type="success" :submit="true" :isLoading="isLoading" :loadingText="'Criando parceria'"></ButtonField>

                </div>
            </form>

        </div>
    </div>

</template>

<script>
    import { useParceriasStore } from '@/stores/parcerias.js'
    import { toast } from 'vue3-toastify'

    const defaultParceria = {nome: '', percentual_desconto: 0}

    export default{
        props:{
            isVisible : {
                type : Boolean,
                default: false
            },
        },
        emits:['close'],
        data(){
            return{
                parceriaStore: useParceriasStore(),
                newParceria: {...defaultParceria},
                isLoading: false
            }
        },
        methods:{
            closeModal(){
                this.$emit('close');
            },
            async addParceria(){
                
                const newParceriaCopy = {...this.newParceria}

                this.isLoading = true
                const result = await this.parceriaStore.add(newParceriaCopy)
                
                this.isLoading = false

                if(result.status){
                    toast.success("Parceria criada com sucesso")
                    this.closeModal()
                    this.newParceria = {...defaultParceria}
                    this.parceriaStore.get()
                }else{
                    toast.error(result.message)
                }

            }
        }
    }
</script>